import React, { Component, Fragment } from "react";
import api from "../../../../services/api";
import MinCard from "../MinCard";

export default class Totais extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            modalidade: "Todas",
            metas: [],
            selectCampo: 0,
            nomeCampo: "numTurmas",
            tipos: [],
            totais: [],
            dr: 0
        }

    }

    async componentDidMount() {
        await this.loadMetas();
        this.calculaTipoPorMes();
    }

    componentDidUpdate(previousProps, previousState) {
        if (previousProps.resultados !== this.props.resultados) {
            this.calculaTipoPorMes();
        }
    }

    loadMetas = async () => {
        let metas = await api.get("/metasformatadas");
        this.setState({ metas: metas.data.metas });
    }

    calculaTipoPorMes = () => {

        let totais = this.props.resultados;

        let dr = ((totais) || []).reduce((acc, total) => acc + total, 0);
        
        let tipo = ["Pago", "Regimental", "Não-Regimental"];

        this.setState({
            tipos: tipo,
            totais: totais,
            dr: dr
        });

    }

    render() {
        return (
            <Fragment>
                <div className="row">
                    {this.state.tipos.map((tipo, i) => {
                        return <MinCard tipo={tipo} valor={this.state.totais && this.state.totais[i]} key={i} />
                    })}
                    <MinCard tipo={["Total"]} valor={this.state.dr} />
                </div>
            </Fragment>
        )
    }
}